import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { useContextSelector } from 'use-context-selector';

import { FormContext } from '../../../contexts/FormContext';
import { Button, ButtonProps } from '../../Button/Button';

interface FormSubmitProps extends Omit<ButtonProps, 'onClick' | 'type'> {
  checkValidity?: boolean;
}

export const FormSubmit: FC<FormSubmitProps> = ({
  children,
  className,
  checkValidity = false,
  disabled: initialDisabled,
  ...props
}) => {
  const submit = useContextSelector(FormContext, ({ submit }) => submit);

  const {
    formState: { isValid },
  } = useFormContext();

  const disabled = (() => {
    if (checkValidity) {
      return !isValid || initialDisabled;
    }
    return initialDisabled;
  })();

  return (
    <Button
      {...props}
      type="submit"
      onClick={submit}
      disabled={disabled}
      className={className}
    >
      {children}
    </Button>
  );
};
